import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import X from '../Icons/X.js';
const FilterOption = (props) => (React.createElement(StyledFilterOption, { active: props.active },
    props.header && React.createElement("h4", null, props.header),
    props.subheader && React.createElement("p", null, props.subheader),
    React.createElement("div", null, props.children),
    props.active && React.createElement(X, { onClick: props.onDeactivate })));
export default FilterOption;
const StyledFilterOption = styled.div `
  border-left: 2px solid
    ${(props) => (props.active ? THEME.COLOR_ACCENT : 'transparent')};
  margin: 0 -${THEME.GRID_SPACING}px 0 -${THEME.GRID_SPACING + 2}px;
  padding: 10px ${THEME.GRID_SPACING}px 10px ${THEME.GRID_SPACING + 2}px;
  position: relative;
  transition: 0.2s;

  & > h4 {
    margin: 0 0 0.4em 0;
  }

  & > p {
    margin: 0 0 5px 0;
    font-size: 0.9em;
  }

  & > svg {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    transition: 0.2s;
    cursor: pointer;
  }

  &:hover {
    border-left: 2px solid
      ${(props) => (props.active ? THEME.COLOR_ACCENT : 'darkgrey')};
    ${(props) => props.active ? `padding-right: ${THEME.GRID_SPACING * 2.5}px;` : ''}

    & > svg {
      opacity: 1;
    }
  }
`;
//# sourceMappingURL=FilterOption.js.map